import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { PALETTE } from "./constants";
import { S_BAR_CHART_DETAILS } from "./signals";
import { SimpleBarList } from "./SimpleBarList";
import { useTranslation } from "react-i18next";
import { getRankingMax } from "./rankingData";
import { RANKING_FONT } from "./rankingTheme";

export const BarChartDetailsPopup = () => {
	const { t } = useTranslation();
	const requestData = S_BAR_CHART_DETAILS.use();
	if (!requestData) return null;
	const close = () => S_BAR_CHART_DETAILS.invoke(null);
	const colors = requestData.colors ?? PALETTE;
	const maxVal = getRankingMax(requestData.data);
	return (
		<Panel
			sx={{ width: "600px", maxWidth: "90vw", maxHeight: "90vh", overflow: "hidden", fontFamily: RANKING_FONT, fontSize: "13px", lineHeight: 1.45, color: "#344054" }}
			decorator="absolute"
			disableScroll
			growContent
			label={requestData.title}
			onClose={close}>
			<VBox sx={{ gap: "12px", flex: 1, minHeight: 0, overflow: "auto", padding: "4px", paddingRight: "12px" }}>
				<SimpleBarList data={requestData.data} colors={colors} maxVal={maxVal} icon={requestData.icon} />
			</VBox>
			<Spacer size="20px" />
			<HBox sx={{ justifyContent: "end" }}>
				<Button title={t("common.close")} variant="secondary" onClick={close} />
			</HBox>
		</Panel>
	);
};
